module.exports = __webpack_public_path__ + "static/world-6ee6ed2861c796ca29fad91c73e79b53.png";